import GLightbox from "glightbox";

GLightbox({
  touchNavigation: true,
  loopAtEnd: true,
  moreText: "Zobacz więcej",
});
